import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "services/supabaseClient";
import { callFunction } from "lib/edge";
import { validatePassword } from "lib/passwordPolicy";
import PasswordFields from "components/PasswordFields";
import SectionCard from "components/SectionCard";
import FooterCompact from "components/FooterCompact";

export default function SetPassword() {
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();

  useEffect(() => { void supabase.auth.getSession().then(({ data }) => {
    if (!data.session?.user) navigate("/activate", { replace: true });
    else if (data.session.user.app_metadata?.initial_password_set_at) navigate("/signup-user", { replace: true });
    setChecking(false);
  }); }, [navigate]);

  const submit = async (event) => {
    event.preventDefault();
    const validation = validatePassword(password, confirmation);
    if (validation) { setError(validation); return; }
    setLoading(true); setError("");
    try {
      const { error: updateError } = await supabase.auth.updateUser({ password });
      if (updateError) throw updateError;
      await callFunction("invite-user", { body: { action: "complete_password" } });
      await supabase.auth.refreshSession();
      navigate("/signup-user", { replace: true });
    } catch {
      setError("We could not establish your password. Please try again or request a new code.");
    } finally { setLoading(false); }
  };

  if (checking) return null;
  return <div className="min-h-screen bg-app text-app flex flex-col"><div className="flex-1 flex items-center justify-center p-6 bg-surface"><div className="w-full max-w-lg"><h1 className="text-2xl font-semibold">Set Your Password</h1><SectionCard className="mt-4"><form onSubmit={submit} className="space-y-4"><PasswordFields password={password} confirmation={confirmation} onPassword={setPassword} onConfirmation={setConfirmation} disabled={loading} /><button className="btn btn-primary w-full" disabled={loading}>{loading ? "Saving..." : "Continue"}</button></form>{error && <div role="alert" className="mt-4 rounded-md border border-red-300 bg-red-50 p-3 text-sm text-red-700">{error}</div>}</SectionCard></div></div><FooterCompact /></div>;
}
